import React, { useEffect, useState } from "react";
import {
  IoArrowBackOutline,
  IoCashOutline,
  IoSyncOutline,
  IoBanOutline,
  IoGiftOutline,
  IoCallOutline,
  IoPersonOutline,
  IoStorefrontOutline,
  IoBicycleOutline,
  IoShieldCheckmarkOutline,
  IoTimeOutline,
} from "react-icons/io5";
import ChatTab from "../../../pages/technicalSupport/chatTab";
import RefundModal from "../RefundModal";
import FullOrderRefundModal from "../FullOrderRefundModal";
import ReplaceModal from "../ReplaceModal";
import VoucherModal from "../VoucherModal";
import { getOrderActions } from "../../../utils/orderActions";
import { useMutation } from "react-query";
import { updateOrders } from "../../../MyApi/orders";
import { toast } from "react-toastify";
import StartCourierWorkModal from "../../shipping/startWorkModal";
import OrderHeader from "../OrderHeader";
import OrderTimeline from "../OrderTimeline";
import ActionHistoryCards from "../ActionHistoryCards";
import OrderItems from "../OrderItems";
import MultiStoreOrder from "../MultiStoreOrder";
import { Spinner } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { updateCurios } from "../../../MyApi/curior";
import { updateUser } from "../../../MyApi/user";
import { updateStore } from "../../../MyApi/stores";
import AppointCourierModal from "../../orders/show/appointCourierModal";

const ResolutionPanel = ({
  ticket,
  onShowOrderDetails,
  orderItems = [],
  orderId,
  orderData,
  orderLoading,
  refetchOrder,
  refetch,
  setUserId,
  userId,
}) => {
  const [activeTab, setActiveTab] = useState("resolution");
  const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);
  const [isFullRefundModalOpen, setIsFullRefundModalOpen] = useState(false);
  const [isReplaceModalOpen, setIsReplaceModalOpen] = useState(false);
  const [isVoucherModalOpen, setIsVoucherModalOpen] = useState(false);
  const [showStartShiftModal, setShowStartShiftModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [status, setStatus] = useState(ticket?.status || "");
  const [isClosed, setIsClosed] = useState(ticket?.is_closed || false);
  const [showCourierModal, setShowCourierModal] = useState(false);
  const [activeStatus, setActiveStatus] = useState("");

  const storeId = ticket?.store_id;
  console.log("store id", storeId);
  const statusMutation = useMutation({
    mutationKey: ["updateStatus"],
    mutationFn: ({ formData, type, id }) => {
      switch (type) {
        case "courier":
          return updateCurios(formData, id);
        case "user":
          return updateUser(formData, id);
        case "vendor":
          return updateStore(formData, id);
        default:
          throw new Error("Invalid type");
      }
    },
    onSuccess: (data) => {
      toast.success(data.message);
      refetch?.();
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || "حدث خطأ");
    },
  });

  const handleStoreStatus = (checked) => {
    const formData = new FormData();
    formData.append("store[is_closed]", checked ? 0 : 1);
    formData.append("_method", "PUT");
    setIsClosed(!checked);
    statusMutation.mutate({ formData, type: "vendor", id: storeId });
  };

  const handleChangeStatus = (e) => {
    const value = e.target.value;
    setStatus(value);

    const formData = new FormData();
    if (ticket?.type === "courier") formData.append("courier[status]", value);
    if (ticket?.type === "user") formData.append("status", value);
    formData.append("_method", "PUT");

    statusMutation.mutate({
      formData,
      type: ticket?.type,
      id: ticket?.entity_id,
    });
  };
  const handleActiveStatus = (e) => {
    const value = e.target.value;
    setActiveStatus(value);

    const formData = new FormData();
    formData.append("store[active_status]", value);
    formData.append("_method", "PUT");

    statusMutation.mutate({ formData, type: "vendor", id: storeId });
  };
  const getStoreGroupedItems = (orderData) => {
    const order = orderData?.data?.order;
    if (!order?.is_multistore || !order?.children) return order?.items || [];
    return order.children.map((childOrder) => ({
      store: { id: childOrder.store?.id, name: childOrder.store?.name },
      items: childOrder.items || [],
    }));
  };

  const cancelOrderMutation = useMutation({
    mutationKey: ["cancelOrder"],
    mutationFn: (orderId) =>
      updateOrders({ _method: "PUT", status: "cancelled" }, orderId),
    onSuccess: (data) => {
      toast.success(data.message || "تم إلغاء الطلب بنجاح");
      refetchOrder();
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || "حدث خطأ أثناء إلغاء الطلب");
    },
  });

  const availableActions = getOrderActions(orderData?.data?.order || {});

  const isCourierTicket = ticket?.type === "courier";
  const isAccountTicket = ["courier", "user", "vendor"].includes(ticket?.type);
  const hasActions = isAccountTicket || availableActions.length > 0;

  const handleOpenRefundModal = () => setIsRefundModalOpen(true);
  const handleCloseRefundModal = () => setIsRefundModalOpen(false);
  const handleOpenFullRefundModal = () => setIsFullRefundModalOpen(true);
  const handleCloseFullRefundModal = () => setIsFullRefundModalOpen(false);
  const handleOpenReplaceModal = () => setIsReplaceModalOpen(true);
  const handleCloseReplaceModal = () => setIsReplaceModalOpen(false);
  const handleOpenVoucherModal = () => setIsVoucherModalOpen(true);
  const handleCloseVoucherModal = () => setIsVoucherModalOpen(false);
  const handleRefundSuccess = () =>
    console.log("Refund completed successfully");
  const handleFullRefundSuccess = () =>
    console.log("Full order refund completed successfully");
  const handleReplaceSuccess = () =>
    console.log("Product replacement completed successfully");
  const handleVoucherSuccess = () => console.log("Voucher sent successfully");

  const handleCancelOrder = () => {
    if (!orderId) {
      toast.error("رقم الطلب غير متوفر");
      return;
    }
    setShowCancelModal(true);
  };

  const confirmCancelOrder = () => {
    cancelOrderMutation.mutate(orderId);
    setShowCancelModal(false);
  };

  const isMultiStore = orderData?.data?.order?.is_multistore;

  const tabs = [
    { id: 1, key: "chat", label: "المحادثات" },
    { id: 2, key: "resolution", label: "العمليات" },
    { id: 3, key: "details", label: "التفاصيل" },
  ];

  useEffect(() => {
    if (ticket?.ticketID) setActiveTab("chat");
  }, [ticket?.ticketID]);

  const handlePostCourier = () => {
    setShowCourierModal(true);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "resolution":
        return (
          <div>
            <div className="mb-4">
              <div className="d-flex align-items-center mb-3 text-success fw-bold">
                <IoShieldCheckmarkOutline className="me-2" />
                <span>العمليات</span>
              </div>

              {!hasActions ? (
                <div className="text-center text-muted py-5">
                  لا توجد عمليات متاحة لهذا الطلب
                </div>
              ) : (
                <div className="row g-3">
                  {isAccountTicket  && ticket && (
                    <div className="col-12 mb-3">
                      <label className="form-label">حالة الحساب</label>
                      {statusMutation.isLoading ? (
                        <Spinner />
                      ) : ticket?.type === "vendor" ? (
                        <div className="d-flex flex-column gap-3 mt-1">
                          {/* is_closed toggle */}
                          <div className="d-flex align-items-center gap-2">
                            <label>
                              {isClosed ? "المطعم غير متاح" : "المطعم متاح"}
                            </label>
                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={!isClosed}
                                onChange={(e) =>
                                  handleStoreStatus(e.target.checked)
                                }
                              />
                              <span className="slider round"></span>
                            </label>
                          </div>

                          {/* active_status select */}
                          <div>
                            <label className="form-label">حالة النشاط</label>
                            <select
                              className="form-select"
                              value={activeStatus}
                              onChange={handleActiveStatus}
                            >
                              <option value="">اختر الحالة</option>
                              <option value="free">متاح</option>
                              <option value="busy">مشغول</option>
                              <option value="close">مغلق</option>
                            </select>
                          </div>
                        </div>
                      ) : (
                        <select
                          className="form-select"
                          value={status}
                          onChange={handleChangeStatus}
                        >
                          <option value="">اختر الحالة</option>
                          <option value="active">نشط</option>
                          <option value="inactive">غير نشط</option>
                          <option value="blocked">محظور</option>
                        </select>
                      )}
                    </div>
                  )}

                  {isCourierTicket && (
                    <ActionBtn
                      icon={<IoTimeOutline size="1.5rem" />}
                      label="بدء دوام"
                      color="green"
                      onClick={() => setShowStartShiftModal(true)}
                    />
                  )}

                  {availableActions.includes("assign_courier") && (
                    <ActionBtn
                      icon={<IoBicycleOutline size="1.5rem" />}
                      label="تعيين سائق"
                      color="green"
                      onClick={handleOpenRefundModal}
                    />
                  )}

                  {availableActions.includes("refund_item") && (
                    <ActionBtn
                      icon={<IoArrowBackOutline size="1.5rem" />}
                      label="استرداد منتج"
                      color="orange"
                      onClick={handleOpenRefundModal}
                    />
                  )}

                  {availableActions.includes("refund_full_order") && (
                    <ActionBtn
                      icon={<IoCashOutline size="1.5rem" />}
                      label="استرداد طلب كامل"
                      color="red"
                      onClick={handleOpenFullRefundModal}
                    />
                  )}

                  {availableActions.includes("replace_item") && (
                    <ActionBtn
                      icon={<IoSyncOutline size="1.5rem" />}
                      label="استبدال منتج"
                      color="blue"
                      onClick={handleOpenReplaceModal}
                    />
                  )}

                  {availableActions.includes("cancel_order") && (
                    <ActionBtn
                      icon={<IoBanOutline size="1.5rem" />}
                      label="إلغاء طلب"
                      color="red"
                      onClick={handleCancelOrder}
                    />
                  )}

                  {availableActions.includes("send_voucher") && (
                    <ActionBtn
                      icon={<IoGiftOutline size="1.5rem" />}
                      label="إرسال قسيمة"
                      color="purple"
                      onClick={handleOpenVoucherModal}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        );

      case "chat":
        return (
          <ChatTab
            ticketId={ticket?.ticketID}
            onShowOrderDetails={onShowOrderDetails}
            refetch={refetch}
            setUserId={setUserId}
          />
        );

      case "notes":
        return (
          <div className="text-center text-muted py-5">
            ملاحظات المحادثة ستظهر هنا
          </div>
        );

      case "details":
        return (
          <div>
            {orderLoading ? (
              <div className="text-center text-muted py-5">
                جاري التحميل <Spinner />
              </div>
            ) : (
              <>
                <OrderHeader
                  orderData={orderData}
                  isMultiStore={isMultiStore}
                />
                <OrderTimeline orderData={orderData} />
                {isMultiStore ? null : (
                  <ActionHistoryCards orderData={orderData} />
                )}
                <OrderItems orderData={orderData} />
                <MultiStoreOrder orderData={orderData} />
              </>
            )}
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div>
      <div className="card shadow-sm border-0 rounded-4">
        <div className="card-body">
          <div className="d-flex border-bottom mb-4">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                className={`btn-tab ${activeTab === tab.key ? "active" : ""}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>
          <div className="px-4 pb-4">{renderTabContent()}</div>
        </div>
      </div>

      <RefundModal
        isOpen={isRefundModalOpen}
        toggle={handleCloseRefundModal}
        orderId={orderId}
        onSuccess={handleRefundSuccess}
        orderItems={orderItems}
        refetchOrder={refetchOrder}
        orderData={orderData}
        isMultiStore={orderData?.data?.order?.is_multistore}
      />

      <FullOrderRefundModal
        isOpen={isFullRefundModalOpen}
        toggle={handleCloseFullRefundModal}
        orderId={orderId}
        onSuccess={handleFullRefundSuccess}
        refetchOrder={refetchOrder}
      />

      <ReplaceModal
        isOpen={isReplaceModalOpen}
        toggle={handleCloseReplaceModal}
        orderId={orderId}
        onSuccess={handleReplaceSuccess}
        items={getStoreGroupedItems(orderData)}
        refetchOrder={refetchOrder}
        orderData={orderData}
      />

      <VoucherModal
        isOpen={isVoucherModalOpen}
        toggle={handleCloseVoucherModal}
        orderId={orderId}
        onSuccess={handleVoucherSuccess}
        currencySymbol={orderItems?.[0]?.symbol_currency || "EGP"}
        refetchOrder={refetchOrder}
        user_id={userId}
      />

      <StartCourierWorkModal
        show={showStartShiftModal}
        onClose={() => setShowStartShiftModal(false)}
      />

      <AppointCourierModal
        show={showCourierModal}
        onClose={() => setShowCourierModal(false)}
        orderId={orderId}
        refetch={refetch}
      />

      <Modal isOpen={showCancelModal} toggle={() => setShowCancelModal(false)}>
        <ModalHeader toggle={() => setShowCancelModal(false)}>
          تأكيد الإلغاء
        </ModalHeader>
        <ModalBody>هل أنت متأكد من إلغاء هذا الطلب؟</ModalBody>
        <ModalFooter>
          <Button
            color="action-button"
            onClick={() => setShowCancelModal(false)}
          >
            رجوع
          </Button>
          <Button
            color="danger"
            onClick={confirmCancelOrder}
            disabled={cancelOrderMutation.isLoading}
          >
            {cancelOrderMutation.isLoading
              ? "جاري الإلغاء..."
              : "نعم، إلغاء الطلب"}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

const ActionBtn = ({ icon, label, color, onClick }) => (
  <div className="col-6">
    <button
      className={`btn action-button w-100 border p-2 action-${color}`}
      onClick={onClick}
    >
      <span className="me-2 fs-5 d-flex align-items-center">{icon}</span>
      {label}
    </button>
  </div>
);

const ContactCard = ({ icon, title, name, phone, color }) => (
  <div className="d-flex align-items-center flex-wrap justify-content-between p-3 border rounded-3 contact-card">
    <div className="d-flex align-items-center">
      <div className={`contact-icon me-3 text-${color}`}>{icon}</div>
      <div>
        <div className="small fw-bold">
          {title} — <span className="text-muted">{name}</span>
        </div>
        <div className="small text-muted">{phone}</div>
      </div>
    </div>
    <IoCallOutline className="text-muted" />
  </div>
);

export default ResolutionPanel;
